import moment from 'moment-timezone';

export const POST_CAMPAIGN_DAYS = 15;

export const getExtendedCampaignEnd = (
  campaignEnd: string,
  timezone: string,
  days: number = POST_CAMPAIGN_DAYS
): string => moment.tz(campaignEnd, timezone).add(days, 'days').toISOString();

export const isWithinPostCampaignWindow = (
  campaignEnd: string,
  timezone: string,
  days: number = POST_CAMPAIGN_DAYS
): boolean =>
  moment.tz(timezone).isSameOrBefore(moment.tz(getExtendedCampaignEnd(campaignEnd, timezone, days), timezone), 'day');
